// extracted by mini-css-extract-plugin
export var deleteIcon = "_qp-5";
export var deleteOption = "_qp-3";
export var divider = "_qp-2";
export var downloadIcon = "_qp-4";
export var drawer = "_qp-0";
export var drawerFooter = "_qp-6";
export var drawerOpen = "_qp-1";
export var highlighted = "_qp-7";
export var lighterHighlight = "_qp-8";